import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  getCommonTextFilterParams,
  getSetFilterParams,
  getSetDatefilterParams,
} from '../../utils/agGridFilters';
import DeleteConfirmationModal from '../../shared/modal/deleteConfirmation';

const OptionButton = ({
  handleClickOpenEditForm,
  paramsValue,
  handleOpenViewForm,
  rowData,
  handleClickDelete,
}) => {
  const [showConfirmation, setShowConfirmation] = React.useState(false);

  const handleDeleteClick = () => {
    setShowConfirmation(true);
  };

  const handleConfirmDelete = () => {
    handleClickDelete(paramsValue);
    setShowConfirmation(false);
  };

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
  };

  return (
    <div className="action-menu">
      <img
        src="/assets/images/edit.png"
        className="action-img1"
        onClick={() => handleClickOpenEditForm(paramsValue)}
        alt="Edit Product"
        title="Edit Product"
      ></img>

      <img
        src="/assets/images/view.png"
        onClick={() => handleOpenViewForm(paramsValue)}
        className="action-img2"
        alt="View Product"
        title="View Product"
      />

      <img
        src="/assets/images/trash.png"
        className="action-img2"
        onClick={handleDeleteClick}
        alt="Delete Product"
        title="Delete Product"
      ></img>
      <DeleteConfirmationModal
        show={showConfirmation}
        handleClose={handleCloseConfirmation}
        handleConfirm={handleConfirmDelete}
        rowData={rowData}
      />
    </div>
  );
};

const useProductColumnDefs = ({ productList, gridData, handleClickDelete, owner }) => {
  const navigate = useNavigate();
  const commonTextFilterParams = useMemo(() => getCommonTextFilterParams(), []);
  const dateFilterParams = useMemo(() => getSetDatefilterParams(), []);
  const filterParams = useMemo(() => getSetFilterParams, []);

  const handleClickOpenEditForm = (paramsValue) => {
    navigate('/products/productList/editProduct', {
      state: paramsValue,
    });
  };

  const handleOpenViewForm = (paramsValue) => {
    navigate(`/products/productList/viewProduct?id=${paramsValue?.id}`, {
      state: paramsValue,
    });
  };

  const actionsColumn = useMemo(() => {
    return [
      {
        headerName: 'Actions',
        cellRenderer: (params) => {
          if (!params?.node || params.node.group) return null;
          const rowData = { ...params.data, rowIndex: params.rowIndex };
          return (
            <OptionButton
              rowData={rowData}
              handleClickOpenEditForm={() => handleClickOpenEditForm(rowData)}
              handleClickDelete={() => handleClickDelete(rowData)}
              handleOpenViewForm={() => handleOpenViewForm(rowData)}
            />
          );
        },
        maxWidth: 100,
        minWidth: 100,
        sortable: false,
        filter: false,
        pinned: 'left',
      },
    ];
  }, [handleClickOpenEditForm, handleClickDelete]);

  const columnDefs = useMemo(() => {
    return [
      ...actionsColumn,
      {
        headerName: 'Code',
        field: 'code',
        flex: 2,
        filter: 'agTextColumnFilter',
        filterParams: commonTextFilterParams,
      },
      {
        headerName: 'Product Name',
        field: 'name',
        flex: 2,
        filter: 'agTextColumnFilter',
        filterParams: commonTextFilterParams,
      },
      {
        headerName: 'Product Code',
        field: 'productCode',
        flex: 1,
        filter: 'agTextColumnFilter',
        filterParams: commonTextFilterParams,
      },
      {
        headerName: 'Product Owner',
        field: 'productOwner',
        flex: 2,
        filter: 'agSetColumnFilter',
        filterParams: filterParams(owner?.map((item) => item.display_name)),
      },
      {
        headerName: 'Active',
        field: 'productActive',
        flex: 1,
        cellRenderer: (p) => (p.value ? 'Yes' : 'No'),
        filter: 'agSetColumnFilter',
        filterParams: {
          values: [true, false], // actual boolean values
          valueFormatter: (params) => (params.value ? 'Yes' : 'No'),
          buttons: ['apply', 'reset'],
        },
      },
    ];
  }, [actionsColumn, commonTextFilterParams, filterParams, productList, gridData, owner]);

  return columnDefs;
};

export default useProductColumnDefs;
